import { SIG } from "../../common/apiUrl/sig/sigUrls";
import { API } from "../../common/model/objectTypes";
import { uploadInfo } from "../../utils/apiDescription/sig/upload";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { getSignatureStatusRequestParameter, getSignatureStatusResponseBody, sendForSignatureRequestBody, sendForSignatureWithTextIdRequestBody, uploadAPIsetAccessRequestBody } from "../../utils/sig/apiObject";
import { getSignatureStatusRequestCurl, sendForSignatureRequestCurl, sendForSignatureWithTextIdRequestCurl, setAccessRequestCurl } from "../../utils/sig/sampleJsonRequest";
import { getSignatureJsonResponse } from "../../utils/sig/sampleJsonResponse";

const sendForSignature: API = {
    name: "Send For Signature",
    url: `${API_BASE_URL}/${SIG.UPLOAD.SEND_FOR_SIGNATURE_URL}`,
    method: "POST",
    headers: requestHeaderWithCallback,
    apiInfo: uploadInfo.sendForSignature,
    requestBody: sendForSignatureRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: sendForSignatureRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const sendForSignatureWithTextID: API = {
    name: "Send For Signature(With Text Id)",
    url: `${API_BASE_URL}/${SIG.UPLOAD.SEND_FOR_SIGNATURE_WITH_TEXTid_URL}`,
    method: "POST",
    headers: requestHeaderWithCallback,
    apiInfo: uploadInfo.sendForSignatureWithTextId,
    requestBody: sendForSignatureWithTextIdRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: sendForSignatureWithTextIdRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const setAccess: API = {
    name: "Set Access",
    url: `${API_BASE_URL}/${SIG.UPLOAD.SET_ACCESS_URL}`,
    method: "PUT",
    headers: commonRequestHeader,
    apiInfo: uploadInfo.setAccess,
    requestBody: uploadAPIsetAccessRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: setAccessRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const getSignatureStatus: API = {
    name: "Signature Status",
    url: `${API_BASE_URL}/${SIG.UPLOAD.GET_SIGNATURE_STATUS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: uploadInfo.getSignatureStatus,
    requestBody: getSignatureStatusRequestParameter,
    responseBody: getSignatureStatusResponseBody,
    jsonRequest: getSignatureStatusRequestCurl,
    jsonResponse: getSignatureJsonResponse,
}


export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Send For Signature':
            return sendForSignature;
        case 'Send For Signature(With Text Id)':
            return sendForSignatureWithTextID;
        case 'Set Access':
            return setAccess;
        case 'Signature Status':
            return getSignatureStatus;
    }
}
